export default "__VITE_ASSET__DePS1FnF__"